import { AppData } from '../models/appdata'
import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiResponseModel } from '../models/api_response_model';

import { ApiRequestModel } from '../models/api_request_model';

import {
  ActorPersonalInfoRequest, ActorContactInfoRequest, ActorLegalInfoRequest, ActorEducationInfoRequest,ServiceBranchMapByFormattedCodeRequest,
  ActorEmpHistoryInfoRequest, ActorProfessionalReferenceRequest, ActorEmploymentPreferencesRequest, ActorProfileSummaryRequest, ActorDashBoardProfileSummaryInfoRequest, ActorPersonalDetailInfoRequest, ActorSpecialtyRequest, ActorPrefRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest
} from '../models/profileinfo/profileinfo.model';
import {
  ActorCertificationRequest, ActorMedicalFitnessRequest, xSearchProfileInfoRequest,
  AllActorCertificatesRequest, NurseProfilesInfoByRegistryRequest, ActorCertificatesInfoByRegistryRequest, ActorLicenseRequest, ServiceCategoriesRequest, ServicesByCategoryCodeRequest,
} from '../models/actor/actor';
import { RegistrySummaryInfoRequest, NurseRegistryMapInfoRequest, RegistryNursesInfoOnDemandRequest, MapedRegistriesByNurseInfoRequest } from '../models/registry/registry.model';


@Injectable()
export class HCPService {


  constructor(private http: HttpClient, private injector: Injector, private router: Router) {


  }

  GetActorPersonalInfoController(SendActorPersonalInfoRequest: ActorPersonalInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorPersonalInfo`, (SendActorPersonalInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorPersonalInfo(SendActorPersonalInfoRequest: ActorPersonalInfoRequest) {
    
    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorPersonalInfo`, (SendActorPersonalInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetEmergencyContactInfoController(SendActorContactInfoRequest: EmergencyContactInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetEmergencyContactInfo`, (SendActorContactInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetActorContactInfoController(SendActorContactInfoRequest: ActorContactInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetEmergencyContactInfo`, (SendActorContactInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveEmergencyContactInfo(SendActorContactInfoRequest: EmergencyContactInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveEmergencyContactInfo`, (SendActorContactInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorContactInfo(SendActorContactInfoRequest: ActorContactInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorContactInfo`, (SendActorContactInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorLegalInfoController(SendActorLegalInfoRequest: ActorLegalInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorLegalInfo`, (SendActorLegalInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorLegalInfo(SendActorLegalInfoRequest: ActorLegalInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorLegalInfo`, (SendActorLegalInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorEducationInfoController(SendActorEducationInfoRequest: ActorEducationInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorEducationInfo`, (SendActorEducationInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
 
  
  SaveActorEducationInfo(SendActorEducationInfoRequest: ActorEducationInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorEducationInfo`, (SendActorEducationInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  GetActorPrefsInfoController(SendActorSpecialtyRequest: ActorPrefRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorPrefsInfo`, (SendActorSpecialtyRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorPrefsInfo(SendActorSpecialtyRequest: ActorPrefRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorPrefs`, (SendActorSpecialtyRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetActorSpecialtyInfoController(SendActorSpecialtyRequest: ActorSpecialtyRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorSpecialtyInfo`, (SendActorSpecialtyRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorSpecialtyInfo(SendActorSpecialtyRequest: ActorSpecialtyRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorSpecialty`, (SendActorSpecialtyRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  GetActorEmpHistoryInfoController(SendActorEmpHistoryInfoRequest: ActorEmpHistoryInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorEmpHistoryInfo`, (SendActorEmpHistoryInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorEmpHistoryInfo(SendActorEmpHistoryInfoRequest: ActorEmpHistoryInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorEmpHistoryInfo`, (SendActorEmpHistoryInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  GetActorProfessionalReferencesInfoController(SendActorProfessionalReferenceRequest: ActorProfessionalReferenceRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorProfessionalReferencesInfo`, (SendActorProfessionalReferenceRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorProfessionalReference(SendActorProfessionalReferenceRequest: ActorProfessionalReferenceRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorProfessionalReference`, (SendActorProfessionalReferenceRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  //
  SaveActorEmploymentPreferencesInfo(SendActorEmploymentPreferencesRequest: ActorEmploymentPreferencesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorEmploymentPreferencesInfo`, (SendActorEmploymentPreferencesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorEmploymentPreferencesInfoController(SendActorEmploymentPreferencesRequest: ActorEmploymentPreferencesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorEmploymentPreferencesInfo`, (SendActorEmploymentPreferencesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  //
  SaveActorProfileSummaryInfo(SendActorProfileSummaryRequest: ActorProfileSummaryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorProfileSummaryInfo`, (SendActorProfileSummaryRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorProfileSummaryInfoController(SendActorProfileSummaryRequest: ActorProfileSummaryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorProfileSummaryInfo`, (SendActorProfileSummaryRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  SaveActorCertifications(SendActorCertificationRequest: ActorCertificationRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorCertifications`, (SendActorCertificationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorCertificationsInfoController(SendActorCertificationRequest: ActorCertificationRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorCertificationsInfo`, (SendActorCertificationRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  SaveActorMedicalFitnessInfo(SendActorMedicalFitnessRequest: ActorMedicalFitnessRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorMedicalFitnessInfo`, (SendActorMedicalFitnessRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  SaveActorLicenseInfo(SendActorLicenseRequest: ActorLicenseRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorLicenseInfo`, (SendActorLicenseRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorMedicalFitnessInfoController(SendActorMedicalFitnessRequest: ActorMedicalFitnessRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorMedicalFitnessInfo`, (SendActorMedicalFitnessRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetActorLicensesInfoController(SendActorLicenseRequest: ActorLicenseRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorLicenseInfo`, (SendActorLicenseRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  GetRegistrySummaryInfoController(SendRegistrySummaryInfoRequest: RegistrySummaryInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetRegistrySummaryInfo`, (SendRegistrySummaryInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //-------------------------
  GetNurseRegistryMapInfoController(SendNurseRegistryMapInfoRequest: NurseRegistryMapInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetNurseRegistryMapInfo`, (SendNurseRegistryMapInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  SaveNurseRegistryMapInfo(SendNurseRegistryMapInfoRequest: NurseRegistryMapInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveNurseRegistryMapInfo`, (SendNurseRegistryMapInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //-------------------------
  xSearchActorProfileInfoController(SendxSearchProfileInfoInfoRequest: xSearchProfileInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/xSearchActorProfileInfo`, (SendxSearchProfileInfoInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  GetRegistryNursesInfoOnDemandController(SendRegistryNursesInfoOnDemandRequest: RegistryNursesInfoOnDemandRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetRegistryNursesInfoOnDemand`, (SendRegistryNursesInfoOnDemandRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  /////////////////////
  //
  GetDashBoardProfileSummaryController(SendActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetDashBoardProfileSummary`, (SendActorDashBoardProfileSummaryInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  //
  //GetPatientInfoByFormattedCodeController(SendPatientInfoByFormattedCodeRequest: ActorDashBoardProfileSummaryInfoRequest) {

  //  return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetPatientInfoByFormattedCodeController`, (SendPatientInfoByFormattedCodeRequest),
  //    {
  //      headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
  //    }
  //  ).pipe(catchError(this.handleError));
  //}
  GetActorPersonalDetailInfoController(SendActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorPersonalDetailInfo`, (SendActorPersonalDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }
  SaveActorPersonalDetailInfo(SendActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/SaveActorPersonalDetailInfo`, (SendActorPersonalDetailInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //-----------------------------------------

  //
  GetAllActorCertificatesInfoController(SendAllActorCertificatesRequest: AllActorCertificatesRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetAllActorCertificatesInfo`, (SendAllActorCertificatesRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //---------------------------------------------------------
  GetNurseProfilesInfoByRegistryController(SendNurseProfilesInfoByRegistryRequest: NurseProfilesInfoByRegistryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetNurseProfilesInfoByRegistry`, (SendNurseProfilesInfoByRegistryRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }


  //
  GetActorCertificatesInfoByRegistryController(SendActorCertificatesInfoByRegistryRequest: ActorCertificatesInfoByRegistryRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetActorCertificatesInfoByRegistry`, (SendActorCertificatesInfoByRegistryRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

  //
  GetMapedRegistriesByNurseInfoController(SendMapedRegistriesByNurseInfoRequest: MapedRegistriesByNurseInfoRequest) {

    return this.http.post<ApiResponseModel>(`${AppData.GlobalApiUrl}HCP/GetMapedRegistriesByNurseInfo`, (SendMapedRegistriesByNurseInfoRequest),
      {
        headers: new HttpHeaders().set('AuthGenKEY', AppData.Instance().UserLoginDetails.AuthGenKEY)
      }
    ).pipe(catchError(this.handleError));
  }

 



  private handleError(error: any) {


    if (error.status === 400) {

      return Promise.reject('Request Failed Due to Bad Request..!');
    }
    //else if (error.status === 401) {
    //  return this.unauthorised();
    //  //return Promise.reject('UnAuthorised Request..!');

    //}
    else if (error.status === 401) {

      //  this.router.navigate(['login']);;;
      //return this.unauthorised();
      return Promise.reject('401 - Unauthorized');

    }
    else if (error.status === -1212401) {

      //  this.router.navigate(['login']);;;
      return this.unauthorised();
      //return Promise.reject('UnAuthorised Request..!');

    }
    else if (error.status === 500) {
      return Promise.reject('Internal Server Error..!');

    }
    else {


      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Promise.reject(error.message || error);
    }
  }
  unauthorised(): Observable<any> {

    this.router.navigate(['signinpage']);
    return throwError(() => ({}));
  }

}
